import Main from "../components/Layout/Main";
import Seller from "../components/Layout/Seller";

const apps : any[] = [
    {
        component : Main,
        subdomains : ['www', ''],
        isMain : true
    },
    {
        component : Seller,
        subdomains : ['seller', 'sellerdev'],
        isMain : false
    },
]

export default apps;